import { Box, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import styled from "styled-components"

const InfoTitle = styled(Typography).attrs({ as: "h1" })`
  font-size: 26px;
  font-weight: 300;
  letter-spacing: 1px;
  margin-bottom: 18px;
  text-transform: capitalize;
  text-align: center;
`

const InfoLayout = ({ children, heading, layout, title }) => {
  return (
    <>
      {layout && (
        <Box contain mt={4} px={{ _: "10px", tablet: 2 }}>
          <InfoTitle>{heading || title}</InfoTitle>
        </Box>
      )}
      {children}
    </>
  )
}

InfoLayout.propTypes = {
  children: PropTypes.element.isRequired,
  heading: PropTypes.string,
  layout: PropTypes.string,
  title: PropTypes.string,
}

export default InfoLayout
